/* eslint-disable import/order */
import { useMemo } from 'react';

import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useActivationId } from '@atlassian/jira-tenant-context-controller/src/components/activation-id/index.tsx';
import { useOrgId } from '@jira/router-resources__navigation-organization-id/src/useOrgId.tsx';
import type { Workspace } from '@atlassian/viz-platform-views';

export function useAvpWorkspace(workspaceId?: string | null): Workspace {
	const activationId = useActivationId();
	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();

	return useMemo(
		() =>
			// oxlint-disable-next-line typescript/consistent-type-assertions -- partial workspace asserted to viz contract
			({
				id: workspaceId ?? activationId,
				cloud_id: cloudId,
				// TODO: properly add the access levelπ
				access: 2, // ACCESS.EDIT
				atlassian_org_id: orgId,
				is_data_compliant: true,
			}) as unknown as Workspace,
		[activationId, cloudId, orgId, workspaceId],
	);
}
